class CheckoutV2 {
	constructor(parent, data) {
		this.parent = parent
        this.data = data
		this.steps = []
		this.summaries = []
		this.currentStep = 0
	}

	run() {
		const checkoutElement = document.querySelector('[data-checkout-v2]')

		if (!checkoutElement) {
			return
		}

        checkoutElement.querySelectorAll('[data-checkout-step]').forEach((el) => {
			const step = new CheckoutStep(el, this)
			step.run()
			this.steps.push(step)
		})

		checkoutElement.querySelectorAll('[data-checkout-summary]').forEach((el) => {
			const summary = new CheckoutSummary(el, this)
			summary.run()
			this.summaries.push(summary)
		})

		this.fetchNextView(this.currentStep)
			.then(() => {
				this.updateView(this.currentStep);
			})
			.catch(() => {

			})

		this.updateSummary()
    }

	getTotalSteps() {
		return this.steps.length
	}

	getTotalStepsIdx() {
		return this.getTotalSteps() - 1
	}

	getCurrentStep() {
		return this.currentStep
	}

	setCurrentStep(idx) {
		this.currentStep = idx
	}

	gotToNextStep() {
		if (this.getTotalStepsIdx() < this.getCurrentStep()) {
			return
		}
		else if (this.getTotalStepsIdx() == this.getCurrentStep()) {
			this.fetchNextView(this.getCurrentStep(), this.getCurrentStep())
			return
		}

		this.fetchNextView(this.getCurrentStep() + 1, this.getCurrentStep())
			.then(() => {
				this.setCurrentStep(this.getCurrentStep() + 1)
				this.updateView(this.getCurrentStep())
				this.updateSummary()
			}).catch(() => {

			})
	}

	gotToPrevStep() {
		if (0 === this.getCurrentStep()) {
			return
		}

		this.setCurrentStep(this.getCurrentStep() - 1)
		this.updateView(this.getCurrentStep())
	}

	fetchNextView(newState, prevState = -1) {
		return new Promise((resolve, reject) => {
			let newStep = null
			let prevStep = null
			for (let index = 0; index <= this.getTotalStepsIdx(); index++) {
				if (index === newState) {
					newStep = this.steps[index]
					break
				}
			}

			if (null === newStep) {
				reject()
			}

			if (prevState > -1) {
				this.steps[prevState].showLoading()
				prevStep = this.steps[prevState]
				prevStep.submitFormIfExists()
					.then(() => {
						newStep.updateContent()
						.then(() => {
							this.steps[prevState].hideLoading()
							resolve()
						}).catch(() => {
							reject()
						})
					})
					.catch(() => {
						this.steps[prevState].hideLoading()
						reject()
					})
			} else {
				newStep.updateContent()
					.then(() => {
						if (prevState > -1) {
							this.steps[prevState].hideLoading()
						}
						resolve()
					}).catch(() => {
						reject()
					})
			}
		})
	}

	updateView(newState) {
		for (let index = 0; index <= this.getTotalStepsIdx(); index++) {
			if (index < newState) {
				this.steps[index].isDone()
			} else if (index === newState) {
				this.steps[index].isInProgress()
			} else if (index > newState) {
				this.steps[index].isNext()
			}
		}
	}

	updateSummary() {
		this.summaries.forEach(el => {
			el.update()
		})
	}
}

class CheckoutStep {
	constructor(el, parent) {
		this.el = el
		this.parent = parent
		this.content = null
	}

	run() {
		this.el.querySelectorAll('[data-checkout-next]').forEach((el) => {
			el.addEventListener('click', () => {
				this.parent.gotToNextStep()
			})
		})

		this.el.querySelectorAll('[data-checkout-prev]').forEach((el) => {
			el.addEventListener('click', () => {
				this.parent.gotToPrevStep()
			})
		})

		this.linkContent()
	}

	linkContent() {
		const elContent = this.el.querySelector('[data-checkout-content]')
		if (!elContent) {
			return
		}
		this.content = new CheckoutContent(elContent, this)
		this.content.run()
	}

	showLoading() {
		this.el.querySelectorAll('[data-checkout-next]').forEach((el) => {
			el.classList.add('button1--is-loading')
			el.disabled = true
		})
		this.el.querySelectorAll('[data-checkout-prev]').forEach((el) => {
			el.disabled = true
		})
	}

	hideLoading() {
		this.el.querySelectorAll('[data-checkout-next]').forEach((el) => {
			el.classList.remove('button1--is-loading')
			el.disabled = false
		})
		this.el.querySelectorAll('[data-checkout-prev]').forEach((el) => {
			el.disabled = false
		})
	}

	updateContent() {
		return new Promise((resolve, reject) => {
			if (null === this.content) {
				reject()
			}
			this.content.update()
				.then(() => {
					resolve()
				}).catch(() => {
					reject()
				})
		})
	}

	submitFormIfExists() {
		return new Promise((resolve, reject) => {
			const formElement = this.el.querySelector('form')

			if (!formElement) {
				resolve(false)
				return
			}

			if (formElement.dataset.submit) {
				formElement.submit();
				return;
			}

			const formData = new FormData(formElement)
			fetch(formElement.dataset.action, {
				body: formData,
				method: 'POST'
			})
				.then(response => response.json())
				.then(data => {
					if (!data.ok) {
						reject()
						return
					}
					if (!data.valid) {
						this.content.updateView(data.content)
						reject()
						return
					}
					this.content.updateView(data.content)
					resolve(true)
				})
		})
	}

	isInProgress() {
		this.el.classList.remove('details1--checkout-step-is-done')
		this.el.classList.add('details1--checkout-step-is-in-progress')
		this.el.classList.add('details1-is-active')
	}

	isDone() {
		this.el.classList.remove('details1-is-active')
		this.el.classList.remove('details1--checkout-step-is-in-progress')
		this.el.classList.add('details1--checkout-step-is-done')
	}

	isNext() {
		this.el.classList.remove('details1-is-active')
		this.el.classList.remove('details1--checkout-step-is-done')
		this.el.classList.remove('details1--checkout-step-is-in-progress')
	}
}

class CheckoutSummary {
	constructor(el, parent) {
		this.el = el
		this.parent = parent
		this.content = null
	}

	run() {
		const elContent = this.el.querySelector('[data-checkout-content]')
		if (!elContent) {
			return
		}
		this.content = new CheckoutContent(elContent, this)
		this.content.run()
	}

	update() {
		this.content.update()
	}
}

class CheckoutContent
{
	constructor(el, parent) {
		this.el = el
		this.parent = parent
		this.url = null
	}

	run() {
		this.url = this.el.dataset.checkoutContent
		if (null === this.url || '' === this.url || undefined === this.url) {
			return
		}
	}

	update() {
		return new Promise((resolve, reject) => {
			fetch(this.url)
				.then(response => response.json())
				.then(data => {
					if (!data.ok) {
						reject()
						return
					}
					this.updateView(data.content)
					resolve(true)
				})
			})
	}

	updateView(html) {
		this.el.innerHTML = html
		this.parent.el.dispatchEvent(new Event('view-update'))
	}
}

export default CheckoutV2
